// React and related imports
import React from 'react';

// Assets (images)
import logo from '../../assets/images/Logo_light.png';

export const LogoImage: React.FC = () => {
  return <img src={logo} className="me-1 h-12 sm:h-9" alt="Tazzaka Logo" />;
};
